var map = {
	"./agentassist/bot.png": 59068,
	"./basset/bot.png": 65598,
	"./bcx/bot.png": 58857,
	"./blueoak/bot.png": 64209,
	"./default/bot.png": 37901,
	"./eskom/bot.png": 68561,
	"./ezconnect/bot.png": 37187,
	"./momentum/bot.png": 86806,
	"./secumed/bot.png": 42440,
	"./tigerbrands/bot.png": 39189,
	"./tongaat/bot.png": 35818,
	"./xib-demo/bot.png": 29927
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64191;